import type { CryptoManager } from './manager';

const USD_PAIR = '/USD';

function baseSymbolFromUsdPair(fullSymbol: string): string {
  return fullSymbol.split('/')[0];
}

export function isUSDCryptoSymbol(symbol: string | undefined): boolean {
  return typeof symbol === 'string' && symbol.includes(USD_PAIR);
}

export function getCryptoLogo(logoMap: Record<string, string>, fullSymbol: string): string | undefined {
  return isUSDCryptoSymbol(fullSymbol) ? logoMap[baseSymbolFromUsdPair(fullSymbol).toUpperCase()] : undefined;
}

export async function getCryptoLogoMap(
  cryptoManager: CryptoManager,
  fullSymbols: string[],
): Promise<Record<string, string>> {
  const usdSymbols = fullSymbols.filter(isUSDCryptoSymbol);
  if (usdSymbols.length === 0) return {};
  const baseSymbols = [...new Set(usdSymbols.map(baseSymbolFromUsdPair))];
  const result = await cryptoManager.getCoins(baseSymbols);
  const map: Record<string, string> = {};
  if (result.ok) {
    for (const coin of result.ok) {
      if (coin?.image) map[coin.symbol.toUpperCase()] = coin.image;
    }
  }
  return map;
}
